import { render, staticRenderFns } from "./purchaserInfo.vue?vue&type=template&id=851d2dec&scoped=true"
import script from "./purchaserInfo.vue?vue&type=script&lang=js"
export * from "./purchaserInfo.vue?vue&type=script&lang=js"
import style0 from "./purchaserInfo.vue?vue&type=style&index=0&id=851d2dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851d2dec",
  null
  
)

export default component.exports